import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import { PagedResultDto } from '../models/paged-result.model';
import { Payment } from '../models/payments.model';
import { PaymentSearchDto } from '../models/payment-request.model';
import {
  SuccessMessage,
  UpdateDifferentialDto,
  SendOverdueNotificationDto
} from '../models/payments/payment-management.model';

@Injectable({ providedIn: 'root' })
export class PaymentManagementService {
  private readonly baseUrl = 'api/Payments';

  private readonly http = inject(HttpClient);

  // ── Payments Search ──────────────────────────────────────────────

  search(
    payload?: Partial<PaymentSearchDto>
  ): Observable<PagedResultDto<Payment>> {
    const params = HttpHelper.toHttpParams(payload ?? {});
    return this.http.get<PagedResultDto<Payment>>(this.baseUrl, { params });
  }

  get(paymentId: string): Observable<Payment> {
    return this.http.get<Payment>(`${this.baseUrl}/${paymentId}`);
  }

  // ── Differentials ────────────────────────────────────────────────

  updateFacilityDifferential(
    facilityId: string,
    body: UpdateDifferentialDto
  ): Observable<SuccessMessage> {
    return this.http.patch<SuccessMessage>(
      `${this.baseUrl}/facilities/${facilityId}/differential`,
      body
    );
  }

  updateContractorDifferential(
    contractorId: string,
    body: UpdateDifferentialDto
  ): Observable<SuccessMessage> {
    return this.http.patch<SuccessMessage>(
      `${this.baseUrl}/contractors/${contractorId}/differential`,
      body
    );
  }

  // ── Notifications ────────────────────────────────────────────────

  sendOverdueNotification(
    body: SendOverdueNotificationDto
  ): Observable<SuccessMessage> {
    return this.http.post<SuccessMessage>(
      `${this.baseUrl}/notifications/invoice-overdue`,
      body
    );
  }
}
